<file-upload [uploadUrl]="uploadUrl" (fileUploaded)="onFileUploaded($event)" [itemAlias]="itemAlias"></file-upload>
<button (click)="onUpload($event)">Tilføj filer</button>

<ul class="item-list">
    <li *ngFor="let f of case.attachments">
        <a (click)="downloadFile(f.path)" target="_blank">{{f.name}}</a>
    </li>
</ul>